import Vue from 'vue'
import vuetify from './plugins/vuetify'
import "vuetify/dist/vuetify.css";
import App from './App.vue'

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js